import { cn } from "@/lib/utils";
import { Lot } from "@prisma/client";
import { Flex, Text } from "@radix-ui/themes";
import React from "react";

interface Props {
  lot: Lot;
  direction?: "row" | "column";
}

function LotIdentifierInfo({ lot, direction = "column" }: Props) {
  return (
    <Flex
      direction={direction}
      className="mb-2"
      gap={direction === "row" ? "2" : "0"}
    >
      <Flex>
        <Text
          className={cn(
            "text-nowrap text-xs text-gray-400",
            "xs-screen-text"
          )}
          style={{ textAlign: "left" }}
        >
          {`Lot ${lot.catalogNumber}`}
        </Text>
      </Flex>
      <Flex
        className={cn(direction === "column" && "h-[35px] -translate-y-0.5")}
      >
        <Text
          className={cn(
            "text-sm",
            direction === "column" ? "line-clamp-2" : "line-clamp-1",
            "sm-screen-text"
          )}
          style={{ lineHeight: "1.1rem", textAlign: "left" }}
        >
          {lot.title}
        </Text>
      </Flex>
    </Flex>
  );
}

export default LotIdentifierInfo;
